// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3qg3f","title":"ClientInsurance_title__233uE","itemText":"ClientInsurance_itemText__3dI2N"};